import axios from "../utils/axios";
import {requests} from "../utils/urls";

const getAllDiscountCode = async (values) => {
    try {
        const response = await axios.get(`${requests.management.discountCode.getAll}?page=${values.page}&paginate=${values.paginate}&${
            values.code && `code=${values.code}&`}`);
        return response;
    } catch (e) {
        return e.response;
    }
};

const getDiscountCodeById = async (discountCodeId) => {
    try {
        const response = await axios.get(requests.management.discountCode.show(discountCodeId));
        return response;
    } catch (e) {
        return e.response;
    }
};

const createDiscountCode = async (values) => {
    try {
        const response = await axios.post(requests.management.discountCode.create, values);
        return response;
    } catch (e) {
        return e.response;
    }
};

const deleteDiscountCode = async (discountCodeId) => {
    try {
        const response = await axios.delete(requests.management.discountCode.delete(discountCodeId));
        return response;
    } catch (e) {
        return e.response;
    }
};

export {
    getAllDiscountCode,
    deleteDiscountCode,
    createDiscountCode,
    getDiscountCodeById,
}